// extracted by mini-css-extract-plugin
export default {"contactCard":"Contact__contactCard___D4nvg","singleRiderLinkBtn":"Contact__singleRiderLinkBtn____v8vO"};